/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const validationWorkflowCreateSlugRegExp = new RegExp('[-a-zA-Z0-9_]+');

export const ValidationWorkflowCreate = zod.strictObject({
    slug: zod.string().regex(validationWorkflowCreateSlugRegExp),
});

export type ValidationWorkflowCreate = zod.input<
    typeof ValidationWorkflowCreate
>;
export type ValidationWorkflowCreateOutput = zod.output<
    typeof ValidationWorkflowCreate
>;
